export const ICE_BASE_API_URL = 'https://gop-api.icirena.ai/sync';
